/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UploadFile } from './UploadFile'
export type ComponentsSlideComponent = {
  id?: number
  title?: string
  visual?: UploadFile
  orientation?: ComponentsSlideComponent.orientation
}
export namespace ComponentsSlideComponent {
  export enum orientation {
    PORTRAIT = 'Portrait',
    LANDSCAPE = 'Landscape',
  }
}
